import { render, staticRenderFns } from "./color-option.vue?vue&type=template&id=d45e6a16&scoped=true&"
import script from "./color-option.vue?vue&type=script&lang=js&"
export * from "./color-option.vue?vue&type=script&lang=js&"
import style0 from "./color-option.vue?vue&type=style&index=0&id=d45e6a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45e6a16",
  null
  
)

export default component.exports